/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BuildingGovIcon20Light = forwardRef('BuildingGovIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M8.153 3.577a3 3 0 0 1 3.694 0l5.845 4.567a.5.5 0 1 0 .616-.788l-5.845-4.567a4 4 0 0 0-4.926 0L1.692 7.356a.5.5 0 1 0 .616.788l5.845-4.567Z" }),
        React.createElement("path", { d: "M6 8.5a.5.5 0 0 0-1 0v6a.5.5 0 1 0 1 0v-6Z" }),
        React.createElement("path", { d: "M9 8.5a.5.5 0 0 0-1 0v6a.5.5 0 1 0 1 0v-6Z" }),
        React.createElement("path", { d: "M11.5 8a.5.5 0 0 1 .5.5v6a.5.5 0 1 1-1 0v-6a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M15 8.5a.5.5 0 0 0-1 0v6a.5.5 0 1 0 1 0v-6Z" }),
        React.createElement("path", { d: "M2 17.5a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 0 1h-15a.5.5 0 0 1-.5-.5Z" })));
});
